import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SearchTemplateModel } from 'src/app/Models/SearchTemplateModel';
import { environment } from 'src/environments/environment';
import { Questions } from 'src/app/Models/Questions';
import { QuestionModel } from 'src/app/Models/QuestionModel';
import { DropdownFiltersModel } from 'src/app/Models/DropdownFiltersModel';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {
   
  httpOptions = {
    headers: new HttpHeaders(
      {
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
    ),
  };
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }
  
  public categoryBoolean = new BehaviorSubject<boolean>(false);
  isArtifactoryCategoryAdded = this.categoryBoolean.asObservable();

  changeData(data: boolean) {
    this.categoryBoolean.next(data);
  }

  public getAllTemplateCategories() {
    const url = `${this.apiUrl}Template/GetAllTemplateCategoriesWithCount`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public checkTemplateNameExists(templatename: string) {
    const url = `${this.apiUrl}Template/CheckTemplateNameAlreadyExists/${templatename}`;
    return this.http.get<any>(url, this.httpOptions);
  } 
  async getFile(url: string) {
    const httpOptions = {
      responseType: 'blob' as 'json'
    };
    const res = await this.http.get(url, httpOptions).toPromise();
    return res;
  }
  public getMostDownloadedTemplates() {
    const url = `${this.apiUrl}Template/GetMostDownloadedTemplates`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getMostRatedTemplates() {
    const url = `${this.apiUrl}Template/GetMostRatedTemplates`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getMostViewedTemplates() {
    const url = `${this.apiUrl}Template/GetMostViewedTemplates`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getAllTemplatesById(id, from, size) {
    const url = `${this.apiUrl}Template/GetAllTemplates?templateId=${id}&from=${from}&size=${size}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public updateViewCount(id) {
    const url = `${this.apiUrl}Template/UpdateViewCountByTemplateId?templateId=${id}`;
    return this.http.post<any>(url, this.httpOptions);
  }
  public downloadTemplate(uuid, sharepointId) {
    const url = `${this.apiUrl}Template/downloadtemplate/${uuid}/${sharepointId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getLatestUploaded(size: number, from: number) {
    const url = `${this.apiUrl}Template/GetLatestUploadedTemplates?size=${size}&from=${from}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public downloadAllTemplate(selectedList) {
    let params = new HttpParams();
    (selectedList).forEach(element => {
      params = params.append('templateIds', element);
    });
    const url = `${this.apiUrl}Template/download/templates?${params}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public deleteTemplate(uuid, categoryId) {
    const url = `${this.apiUrl}Template/delete/${uuid}?categoryId=${categoryId}`;
    return this.http.delete<any>(url, this.httpOptions);
  }
  public moveToFolder(uuid, newSharepointId, newTemplateId, templateName, subTemplateId, subTemplateName) {
    const url = `${this.apiUrl}Template/ChangeTemplateCategory?templateId=${uuid}&newSharePointId=${newSharepointId}
    &newTemplateId=${newTemplateId}&templateName=${templateName}&subTemplateId=${subTemplateId}&subTemplateName=${subTemplateName}`;
    return this.http.put<any>(url, this.httpOptions);
  }
  public MoveTemplatesInBulk(templates) {
    const url = `${this.apiUrl}Template/MoveTemplatesInBulk`;
    return this.http.put<any>(url, templates, this.httpOptions);
  }
  public DeleteTemplatesInBulk(templates) {
    const url = `${this.apiUrl}Template/DeleteTemplatesInBulk`;
    return this.http.put<any>(url, templates, this.httpOptions);
  }

  getPreviewUrltemplate(fileId: string): Observable<any> {
    const url = `${this.apiUrl}Template/getFilePreviewLink/${fileId}`.toString();
    return this.http.get<any>(url);
  }
  getPreviewUrlkms(fileId: string): Observable<any> {
    const url = `${this.apiUrl}Graph/getFilePreviewLink/${fileId}`.toString();
    return this.http.get<any>(url);
  }

  public SearchTemplates(searchTemplateModel) {
    ;
    const url = `${this.apiUrl}Template/SearchTemplates`;
    return this.http.post<any>(url, searchTemplateModel, this.httpOptions);
  }
  public AddTemplates(filesData) {
    ;
    const url = `${this.apiUrl}Template/AddTemplates`;
    return this.http.post<any>(url, filesData, this.httpOptions);
  }
  public EditTemplate(template) {
    const url = `${this.apiUrl}Template/EditTemplate`;
    return this.http.put<any>(url, template, this.httpOptions);
  }
  public DeleteTemplateById(templates) {
    const url = `${this.apiUrl}Template/delete/${templates.id}?categoryId=${templates.categoryId}&sharepointId=${templates.sharepointId}`;

    return this.http.delete<any>(url, this.httpOptions);
  }
  public AddTemplateCategory(result) {
    ;
    const url = `${this.apiUrl}Template/AddTemplateCategory?request=${result.template}&templateDescription=${result.templateDescription}`;
    return this.http.post<any>(url, this.httpOptions);
  }
  public AddSubTemplateCategory(result) {
    const url = `${this.apiUrl}Template/AddSubTemplateCategory?templateSarepointId=${result.sharepointId}`;
    ;
    return this.http.post<any>(url, result.templateTypes, this.httpOptions);
  }

  public AddRating(result) {
    const url = `${this.apiUrl}Template/AddRatingForTemplates?templateId=${result.id}&rating=${result.starRating}&comment=${result.Comments}`;
    ;
    return this.http.post<any>(url, this.httpOptions);
  }
  public GetRatingsByTemplateId(result) {

    const url = `${this.apiUrl}Template/GetRatingsByTemplateId?templateId=${result}`;

    return this.http.get<any>(url, this.httpOptions)
  }
  public UpdateRating(result) {
    const url = `${this.apiUrl}Template/UpdateRatingForTemplate?id=${result.id}&templateId=${result.templateId}&rating=${result.rating}&comment=${result.comments}`;

    return this.http.post<any>(url, this.httpOptions);
  }
  public AddOrUpdateEmailConfiguaration(grade, sendEmail, selectedFrequency) {
    const url = `${this.apiUrl}Template/AddOrUpdateEmailPreference?grade=${grade}&isSendEmail=${sendEmail}&frequencyInMonths=${selectedFrequency}`;
    return this.http.post<any>(url, this.httpOptions);
  }

  GetEmailConfiguration() {
    const url = `${this.apiUrl}Template/GetEmailPreference`;
    return this.http.get<any>(url);
  }
  
  public GetTemplateById(templateId) {
    const url = `${this.apiUrl}Template/GetTemplateById?templateId=${templateId}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  public AddQuestions(questiondata: QuestionModel) {
    ;
    const url = `${this.apiUrl}Template/AddQuestions`;
    return this.http.post<any>(url, questiondata, this.httpOptions);
  
  }
  public GetQuestions(searchType: DropdownFiltersModel){
    const url=`${this.apiUrl}Template/getallquestions`;
    return this.http.post<any>(url,searchType, this.httpOptions);
  }

  public GetOtherProposals(){
    const url=`${this.apiUrl}Template/GetOtherProposals`;
    return this.http.post<any>(url, this.httpOptions);
  }
}
